var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0413 28.7756L20.5724 22.2445L14.0413 15.7135C13.6584 15.3415 13.6584 14.6851 14.0413 14.2913C14.4242 13.8975 15.0915 13.9084 15.4744 14.2913L22.0055 20.8224L28.5256 14.2913C28.9194 13.9084 29.5649 13.9084 29.9587 14.2913C30.3525 14.6742 30.3416 15.3306 29.9587 15.7244L23.4276 22.2445L29.9587 28.7756C30.3416 29.1585 30.3416 29.8149 29.9587 30.2087C29.5758 30.6025 28.9194 30.5916 28.5256 30.2087L22.0055 23.6776L15.4744 30.2087C15.0915 30.5916 14.4351 30.5916 14.0413 30.2087C13.6475 29.8258 13.6584 29.1585 14.0413 28.7756Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    fill: "#D8D8D8",
    stroke: "#979797"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.52d560866364df34b8409742daff6aac.svg";
export { ForwardRef as ReactComponent };